import { View } from 'backbone.marionette';
import template from './index.jst';
import { Model } from 'backbone';
import Radio from "backbone.radio";
const MATCH_CENTRE_CHANNEL = Radio.channel('match_centre');

export class MatchCentreMatchSelect extends View {
	get template() {
		return template;
	}


	ui() {
		return {
			match: '.js-match'
		}
	}
	get className() {
		return 'select-wrapper';
	}


	events() {
		return {
			'change @ui.match': 'changeMatch'
		}
	}

	initialize() {
		this.model = new Model({
			opponents: []
		});

	}

	init(selected_round) {
		this.model.set({
			opponents: selected_round.opponents
		});

		this.render();
	}

	changeMatch() {
		MATCH_CENTRE_CHANNEL.trigger('controls:match:changed', this.getUI('match').val())
	}
}

export default MatchCentreMatchSelect;